import { Typography } from 'shared';
import { Spacers } from 'shared_DEPRECATED/components/Spacer';

import { Content } from 'features/resourceBank/components';

const ResourceBankPage = () => {
  return (
    <Spacers height="100%" sizes={['lg', 'md']}>
      <Typography type="semiLargeHeading" fontWeight="semibold" color="black">
        Resource Bank
      </Typography>
      <Content />
    </Spacers>
  );
};

export default ResourceBankPage;
